const data = 
{
    sort: {
        TITLE_ASC: "Alphabetical",
        DATE_DESC: "Most Recent"
    },
    points: {
        1: 1, // Article
        3: 1, // Audio
        4: 1, // File,
        2: 1, // Video,
        11: 10, // Replays 
        12: 1 // Recipes
    },
    noimage: "/images/general/yfp-no-image.jpg",
    s3ImagePath: "https://uploads-core-sandbox.us-east-1.linodeobjects.com",
    defaultImage: "/images/profile-default.jpg"
}
module.exports = data